import React from "react";
import "swiper/css";
import ApcomPng from "~/images/companyLogo/apcom.png";
import Bellsystem24Png from "~/images/companyLogo/bellsystem24.png";
import ChikaranomotoPng from "~/images/companyLogo/chikaranomoto.png";
import ColowidePng from "~/images/companyLogo/colowide.png";
import CyberagentPng from "~/images/companyLogo/cyberagent.png";
import DaikinPng from "~/images/companyLogo/daikin.png";
import DenaPng from "~/images/companyLogo/dena.png";
import DoutorPng from "~/images/companyLogo/doutor.png";
import DowaPng from "~/images/companyLogo/dowa.png";
import EbaraPng from "~/images/companyLogo/ebara.png";
import FindyPng from "~/images/companyLogo/findy.png";
import FreeePng from "~/images/companyLogo/freee.png";
import GenkyPng from "~/images/companyLogo/genky.png";
import HidahidakayaPng from "~/images/companyLogo/hidahidakaya.png";
import JtPng from "~/images/companyLogo/jt.png";
import KeizaisanngyosyoPng from "~/images/companyLogo/nihonkeisannsyou.png";
import KourakuenPng from "~/images/companyLogo/kourakuen.png";
import KushitanakaPng from "~/images/companyLogo/kushitanaka.png";
import LitalicoPng from "~/images/companyLogo/litalico.png";
import MarubinePng from "~/images/companyLogo/marubeni.png";
import MitsuifudosanrealtyPng from "~/images/companyLogo/mitsuifudosanrealty.png";
import NihonsoukenPng from "~/images/companyLogo/nihonsouken.png";
import OmronPng from "~/images/companyLogo/omron.png";
import OrenoPng from "~/images/companyLogo/oreno.png";
import ReliaPng from "~/images/companyLogo/relia.png";
import SaintmarcholdingsPng from "~/images/companyLogo/saintmarcholdings.png";
import SaisoncardPng from "~/images/companyLogo/saisoncard.png";
import SansanPng from "~/images/companyLogo/sansan.png";
import SbcsPng from "~/images/companyLogo/sbcs.png";
import SbisompoPng from "~/images/companyLogo/sbisompo.png";
import School21Png from "~/images/companyLogo/school21.png";
import SepteniPng from "~/images/companyLogo/septeni.png";
import ShizuokaPng from "~/images/companyLogo/shizuoka.png";
import SophiamediPng from "~/images/companyLogo/sophiamedi.png";
import TechnoprodesignPng from "~/images/companyLogo/technoprodesign.png";
import TiisPng from "~/images/companyLogo/tiis.png";
import ToyoengineeringPng from "~/images/companyLogo/toyoengineering.png";
import ViaholdingsPng from "~/images/companyLogo/viaholdings.png";
import VirtualexPng from "~/images/companyLogo/virtualex.png";
import WelcomePng from "~/images/companyLogo/welcome.png";
import WillofworkPng from "~/images/companyLogo/willofwork.png";
import YakuodoPng from "~/images/companyLogo/yakuodo.png";
import YayoiPng from "~/images/companyLogo/yayoi.png";
import YoshinoyaPng from "~/images/companyLogo/yoshinoya.png";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";

export const LpRpo01PageCompanyLogos: React.FC = () => (
  <>
    <div className="titleWrapper">
      <span className="title">業種・業態・採用職種を問わずに1,000社以上が導入</span>
    </div>
    <div className="companyLogs">
      <div className="scroll-container">
        {/* NOTE: ロゴが途中で途切れないようにScrollContentは２つ繋げる */}
        <ScrollContentPrimary />
        <ScrollContentPrimary />
      </div>
      <div className="scroll-container">
        <ScrollContentSecondary />
        <ScrollContentSecondary />
      </div>
    </div>

    <style jsx>{`
      .titleWrapper {
        margin-top: 48px;
        padding: 0 24px;
        text-align: center;
      }
      .title {
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 2px;
        background: radial-gradient(
            circle at calc(100% - 4px) calc(100% - 4px),
            ${colors.subOrange} 4px,
            transparent 4px
          ),
          radial-gradient(circle at 4px calc(100% - 4px), ${colors.subOrange} 4px, transparent 4px),
          linear-gradient(to bottom, ${colors.white} calc(100% - 8px), transparent calc(100% - 8px)),
          linear-gradient(
            to right,
            transparent 4px,
            ${colors.subOrange} 4px,
            ${colors.subOrange} calc(100% - 4px),
            transparent calc(100% - 4px)
          );
      }
      .companyLogs {
        margin-top: 40px;
        margin-bottom: 24px;
      }
      .scroll-container {
        display: flex;
        overflow: hidden;
        width: 100%;
        white-space: nowrap;
      }
      .scroll-container + .scroll-container {
        margin-top: 8px;
      }
      @media (${breakPoints.sp}) {
        .titleWrapper {
          margin-top: 32px;
          line-height: 36px;
        }
        .title {
          font-size: 24px;
          background: linear-gradient(transparent 70%, ${colors.subOrange} 50%);
        }
        .companyLogs {
          margin-top: 32px;
        }
      }
    `}</style>
  </>
);

const ScrollContentPrimary = () => (
  <>
    <div className="scroll-content">
      <div className="item">
        <img src={Bellsystem24Png} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={ChikaranomotoPng} alt="" />
      </div>
      <div className="item">
        <img src={ColowidePng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={CyberagentPng} alt="" />
      </div>
      <div className="item">
        <img src={DaikinPng} alt="" />
      </div>
      <div className="item">
        <img src={DenaPng} alt="" />
      </div>
      <div className="item">
        <img src={DoutorPng} alt="" />
      </div>
      <div className="item">
        <img src={DowaPng} alt="" />
      </div>
      <div className="item">
        <img src={EbaraPng} alt="" />
      </div>
      <div className="item">
        <img src={FreeePng} alt="" />
      </div>
      <div className="item">
        <img src={HidahidakayaPng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={JtPng} alt="" />
      </div>
      <div className="item">
        <img src={KeizaisanngyosyoPng} alt="" />
      </div>
      <div className="item">
        <img src={LitalicoPng} alt="" />
      </div>
      <div className="item">
        <img src={MarubinePng} alt="" />
      </div>
      <div className="item">
        <img src={MitsuifudosanrealtyPng} alt="" />
      </div>
      <div className="item">
        <img src={NihonsoukenPng} alt="" />
      </div>
      <div className="item itemSmall">
        <img src={OmronPng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={SaintmarcholdingsPng} alt="" />
      </div>
      <div className="item">
        <img src={SaisoncardPng} alt="" />
      </div>
      <div className="item">
        <img src={SansanPng} alt="" />
      </div>
      <div className="item">
        <img src={SbcsPng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={ShizuokaPng} alt="" />
      </div>
      <div className="item">
        <img src={WillofworkPng} alt="" />
      </div>
      <div className="item">
        <img src={YayoiPng} alt="" />
      </div>
      <div className="item">
        <img src={YoshinoyaPng} alt="" />
      </div>
    </div>

    <style jsx>{`
      .scroll-content {
        animation: scroll 56s linear infinite;
        display: flex;
        height: 80px;
      }
      .item {
        align-items: center;
        display: flex;
        margin: 0 28px;
      }
      .item :global(img) {
        height: 40px;
        width: auto;
        object-fit: contain;
      }
      .itemSquare :global(img) {
        height: 56px;
      }
      .itemSmall :global(img) {
        height: 28px;
      }
      @keyframes scroll {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    `}</style>
  </>
);

const ScrollContentSecondary = () => (
  <>
    <div className="scroll-content">
      <div className="item itemSquare">
        <img src={ApcomPng} alt="" />
      </div>
      <div className="item itemSmall">
        <img src={FindyPng} alt="" />
      </div>
      <div className="item">
        <img src={GenkyPng} alt="" />
      </div>
      <div className="item">
        <img src={KourakuenPng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={KushitanakaPng} alt="" />
      </div>
      <div className="item">
        <img src={OrenoPng} alt="" />
      </div>
      <div className="item">
        <img src={ReliaPng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={School21Png} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={SepteniPng} alt="" />
      </div>
      <div className="item itemSmall">
        <img src={SbisompoPng} alt="" />
      </div>
      <div className="item">
        <img src={SophiamediPng} alt="" />
      </div>
      <div className="item">
        <img src={TechnoprodesignPng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={TiisPng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={ToyoengineeringPng} alt="" />
      </div>
      <div className="item itemSquare">
        <img src={ViaholdingsPng} alt="" />
      </div>
      <div className="item">
        <img src={VirtualexPng} alt="" />
      </div>
      <div className="item">
        <img src={WelcomePng} alt="" />
      </div>
      <div className="item">
        <img src={YakuodoPng} alt="" />
      </div>
    </div>

    <style jsx>{`
      .scroll-content {
        animation: scroll 40s linear infinite;
        display: flex;
        height: 80px;
      }
      .item {
        align-items: center;
        display: flex;
        margin: 0 28px;
      }
      .item :global(img) {
        height: 40px;
        width: auto;
        object-fit: contain;
      }
      .itemSquare :global(img) {
        height: 56px;
      }
      .itemSmall :global(img) {
        height: 28px;
      }
      @keyframes scroll {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    `}</style>
  </>
);
